(function($){
    // Accordion + Masonry
    $('.chapter h3').click(function(){
        $(this).parent().parent().toggleClass('plegat');
    });
    $('.plegat h3').click(function(){
    	var $grid = $('.grid-masonry').masonry({
            itemSelector: '.grid-item',
            percentPosition: true,
            transitionDuration: 0
        });
        $grid.imagesLoaded().progress(function() {
            $grid.masonry('layout');
        }); 
    });
	// Form
	$('.form-section .fieldset input, .form-section .fieldset textarea').blur(function(){
    	if($(this).val()) {
        	$(this).addClass('filled');
    	} else {
        	$(this).removeClass('filled');
    	}
	});
	$('.wpcf7').on('wpcf7:mailsent', function(event) {
		$('.form-section .fieldset input, .form-section .fieldset textarea').removeClass('filled');
	});

    // Datepicker customization
    $( document ).ready(function() {

        if ( $.isFunction($.fn.datepicker) ) {
            
            $( ".hasDatepicker" ).datepicker( "option", "changeYear", true );
            $( ".hasDatepicker" ).datepicker( "option", "yearRange", "1900:2018" );
            $( ".hasDatepicker" ).datepicker( "option", "onClose", function(dateText, inst) {
                if($(this).val()) {
                    $(this).addClass('filled');
                } else {
                    $(this).removeClass('filled');
                }
            });
        }
    });
	
	// Autogrow textareas
	$('textarea').autogrow({
    	horizontal: false,
	});
})(jQuery);